import * as React from 'react';
import EmojiPicker, { EmojiClickData, Theme } from 'emoji-picker-react';
import { Smile } from 'lucide-react';

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from '@/components/molecules/popover';
import { Button } from '@/components/atoms/button';

// ============ Types ============

interface EmojiPickerButtonProps {
  onEmojiSelect: (emoji: string) => void;
}

// ============ Component ============

export function EmojiPickerButton({ onEmojiSelect }: EmojiPickerButtonProps) {
  const [open, setOpen] = React.useState(false);

  const handleEmojiClick = (emojiData: EmojiClickData) => {
    onEmojiSelect(emojiData.emoji);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" type="button">
          <Smile className="size-4 mr-1" />
          Emojis
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-0" align="end" sideOffset={8}>
        <EmojiPicker
          onEmojiClick={handleEmojiClick}
          width="100%"
          height={350}
          searchDisabled={false}
          skinTonesDisabled
          previewConfig={{ showPreview: false }}
          theme={Theme.AUTO}
          lazyLoadEmojis
        />
      </PopoverContent>
    </Popover>
  );
}
